import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/dist/ScrollTrigger'
import Swiper from 'swiper/bundle'
gsap.registerPlugin(ScrollTrigger)

/**
 * PressBlock component.
 * @author Dayne Coulson-Hoffacker
 */
export default class PressBlock {
  /**
   * Constructs a new PressBlock component.
   * @param {Object} options - Options.
   * @param {HTMLElement} options.element - Container.
   */
  constructor (options) {
    this.element = options.element
    this.shapesBg = this.element.querySelector('[data-component="shapes-bg"]')
    this.imageEl = this.shapesBg.querySelector('picture')
    this.swiperContainer = this.element.querySelector('.swiper-container')

    var slider = new Swiper(this.swiperContainer, {
      slidesPerView: 1,
      loop: true,
      autoplay: {
        delay: 3000
      },
      spaceBetween: 30,
      autoHeight: true,
      centeredSlides: true,
      breakpoints: {
        768: {
          slidesPerView: 2,
          spaceBetween: 30,
        },
        1180: {
          slidesPerView: 5,
          spaceBetween: 96,
        }
      }
    })

    slider.autoplay.stop()

    const pressBlockTL = gsap.timeline({ paused: true })
    pressBlockTL.to(this.shapesBg, { duration: 1, autoAlpha: 1, ease: 'power2' })
    pressBlockTL.to(this.imageEl, { duration: 0.5, autoAlpha: 1, scale: 1, ease: 'power2' }, '<')
    pressBlockTL.to(this.swiperContainer, { duration: 0.5, autoAlpha: 1, ease: 'power2' }, '.5')
    ScrollTrigger.create({
      trigger: this.element,
      start: 'top bottom',
      markers: false,
      scroller: 'body',
      onEnter: () => {
        pressBlockTL.play()
        slider.autoplay.start()
      }
    })
  }
}



// WEBPACK FOOTER //
// ./components/section/press-block/index.js